import { useEffect, useState } from "react";
import { PawPrint } from "lucide-react";
import { useLang } from "../lib/i18n";

const PAW_TRAIL = [
  { x: 10, y: 70, rot: -12, delay: 0 },
  { x: 22, y: 50, rot: 8, delay: 0.18 },
  { x: 34, y: 70, rot: -10, delay: 0.36 },
  { x: 46, y: 50, rot: 10, delay: 0.54 },
  { x: 58, y: 70, rot: -8, delay: 0.72 },
  { x: 70, y: 50, rot: 12, delay: 0.9 },
  { x: 82, y: 70, rot: -6, delay: 1.08 },
];

export default function LoadingScreen({ onDone }) {
  const [progress, setProgress] = useState(0);
  const [hide, setHide] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    const start = Date.now();
    const total = 1700;
    const id = setInterval(() => {
      const p = Math.min(100, ((Date.now() - start) / total) * 100);
      setProgress(p);
      if (p >= 100) {
        clearInterval(id);
        setTimeout(() => setHide(true), 250);
        setTimeout(() => onDone && onDone(), 650);
      }
    }, 30);
    return () => clearInterval(id);
  }, [onDone]);

  return (
    <div
      data-testid="loading-screen"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500 ${
        hide ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      style={{ background: "var(--pm-bg)" }}
    >
      {/* Paw trail */}
      <div className="absolute inset-0 overflow-hidden">
        {PAW_TRAIL.map((p, i) => (
          <PawPrint
            key={i}
            className="paw-step absolute text-slate-900"
            style={{
              left: `${p.x}%`,
              top: `${p.y}%`,
              width: 36,
              height: 36,
              animationDelay: `${p.delay}s`,
              "--rot": `${p.rot}deg`,
              transform: `rotate(${p.rot}deg)`,
              opacity: 0.85,
            }}
          />
        ))}
      </div>

      {/* Center logo card */}
      <div className="relative z-10 flex flex-col items-center">
        <div className="neo-card px-8 py-6 flex items-center gap-3 fade-up">
          <div
            className="w-12 h-12 rounded-xl flex items-center justify-center bounce-y"
            style={{ background: "var(--pm-dog)" }}
          >
            <PawPrint className="text-white" size={28} />
          </div>
          <div className="text-start">
            <div className="font-display text-3xl font-bold leading-none">Pet Munchies</div>
            <div className="text-xs text-slate-600 mt-1">{t("loading.subtitle")}</div>
          </div>
        </div>

        <div className="mt-8 w-64 h-3 neo-flat overflow-hidden p-0">
          <div
            data-testid="loading-progress"
            className="h-full transition-all duration-100"
            style={{ width: `${progress}%`, background: "var(--pm-dog)" }}
          />
        </div>
        <div className="mt-3 text-xs text-slate-600 font-medium tracking-wide">
          {t("loading.progress")} {Math.round(progress)}%
        </div>
      </div>
    </div>
  );
}
